__turbopack_context__.v({
  "amount": "MM7PHa_amount",
  "amountAffix": "MM7PHa_amountAffix",
  "card": "MM7PHa_card",
  "cta": "MM7PHa_cta",
  "note": "MM7PHa_note",
  "price": "MM7PHa_price",
  "priceLabel": "MM7PHa_priceLabel",
  "suffix": "MM7PHa_suffix",
});
